import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const CategoriesCardContainer = styled(Link)`
  border-radius: var(--br-l);
  overflow: hidden;
  position: relative;
  max-height: 250px;
`;

export const CategoriesCardOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  font-weight: bold;
  color: #fff;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  border-radius: var(--br-l);
  &:hover {
    background-color: rgba(249, 112, 62, 0.7);
    transform: scale(1.4);
  }
`;
